export default __webpack_public_path__ + "static/media/icon_physique_chimie.7c78cee1.png";